'use strict';


export default class Menu {
	constructor() {
		
		//console.log($(window).width);
		if( $("nav").length > 0 ) {
			
			//$('.sub-menu').hide();
			
			//if ($(window).width() <= 1025) { //mobile menu
				
				//$("nav").height($("body").height());
				
				$('#mobile-menu, .overlay').on('click', function(){
					$(this).toggleClass('is-active');
					$('nav').toggleClass('is-active');
					$('.overlay').toggle();
				});
				
				$(".menu__toggle").on("click",function(){
					$(this).toggleClass('menu__toggle--open');
					$(this).siblings("ul").slideToggle();
				})
				
			//}
		}	
	}
}